import type {Notification as NotificationType} from "@client/features/notifications";
import {Notification} from "@client/shared/components/Notification";
import {AnimatePresence, motion} from "motion/react";
import * as React from "react";

interface Props {
    notifications: NotificationType[];
    dismissHandler?: (notification: NotificationType) => void;
}

export const Notifications = (props: Props) => {
    const {dismissHandler} = props;

    return (
        <div className="notifications-site mx-auto mt-2.5 flex max-w-[900px] shrink-0 basis-auto flex-col space-y-5 px-2.5">
            <AnimatePresence initial={false}>
                {props.notifications.map((notification) => (
                    <motion.div
                        key={notification.id}
                        initial={{opacity: 0, scale: 0.3}}
                        animate={{opacity: 1, scale: 1}}
                        exit={{opacity: 0, scale: 0.2, transition: {duration: 0.3}}}
                    >
                        <Notification
                            onDismiss={
                                dismissHandler != null
                                    ? () => dismissHandler(notification)
                                    : undefined
                            }
                            notification={notification}
                        />
                    </motion.div>
                ))}
            </AnimatePresence>
        </div>
    );
};
